import { BrokerageGetRequestQuery } from '@lio/api-types';

export const getBrokeragesQuery = ({
  pageLimit,
  pageOffset,
  parentId,
  name,
  mdmBrokerageId,
  sort,
  entityStatus,
}: BrokerageGetRequestQuery) => {
  const query = new URLSearchParams();

  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }
  if (parentId) {
    query.append('parentId', parentId);
  }
  if (name) {
    query.append('name', name);
  }
  if (mdmBrokerageId) {
    query.append('mdmBrokerageId', mdmBrokerageId);
  }
  if (sort) {
    query.append('sort', sort.toString());
  }
  if (entityStatus) {
    entityStatus.forEach((status) => {
      query.append('entityStatus', status);
    });
  }
  return query.toString();
};
